module.exports = __webpack_public_path__ + "img/landing-main-img.c35af823.svg";